module.exports = __webpack_public_path__ + "img/9788949120676.c813f212.jpg";